<template>
  <b-card :title="$t('organizationSearch')">
    <b-form inline @reset="resetFilter" v-on:submit.prevent>
      <b-input-group id="organization-group" class="mr-4">
        <label class="mr-2" > {{ $t('name') }}</label>
        <b-form-input id="organization_type" type="text" v-model="filter.name" v-on:keyup="onKeyup"/>
      </b-input-group>
      <b-col>
        <b-button type="reset">{{ $t('reset') }}</b-button>
      </b-col>
    </b-form>
  </b-card>

</template>
<script>
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'QuickOrganizationSearch',
    computed:{
      ...mapGetters('organizations', ['filter']),
      ...mapState('organizations', { filter: state => state.filter }),
    } ,
    methods: {
      onKeyup(event) {
        if (event.which === 13) {
          this.organizationSearch()
        }
      },
      organizationSearch(){
        this.$store.dispatch('organizations/getOrganizations')
          .then(() => {
            this.$router.push('/organizations')
          })
      },
      resetFilter(){
        this.$store.dispatch('organizations/resetFilter')
      }
    }
  }
</script>
